import { BufferGeometry } from "three";
import { copyColorToBufferGeometry, copyPositionToBufferGeometry, copyUserIdToBufferGeometry } from "./utils";
export class PointMesh {
    constructor() {
        this.points = [];
        this.geometry = new BufferGeometry();
    }
    resolve() {
        copyPositionToBufferGeometry(this.geometry, this.points);
        if (typeof this.color !== "undefined") {
            copyColorToBufferGeometry(this.geometry, this.color);
        }
        if (typeof this.pickingUserId !== "undefined") {
            copyUserIdToBufferGeometry(this.geometry, this.pickingUserId);
        }
        this.geometry.computeBoundingSphere();
    }
}
